// NFT Collection Configuration
export const NFT_CONFIG = {
  // Pricing
  PRICE_PER_NFT: 0.06, // OKB per NFT

  // Collection Details
  TOTAL_SUPPLY: 10000,
  MAX_MINT_PER_TRANSACTION: 10,

  // Contract Details (replace with actual values when contract is deployed)
  CONTRACT_ADDRESS: '0x0000000000000000000000000000000000000000',

  // Collection Info
  COLLECTION_NAME: 'X CARS',
  COLLECTION_DESCRIPTION: 'X Layer First High-Quality 10k Original NFT',

  // Utility Functions
  calculateTotalCost: (quantity: number): number => {
    return NFT_CONFIG.PRICE_PER_NFT * quantity
  },

  formatPrice: (price: number): string => {
    return `${price.toFixed(2)} OKB`
  }
}

export default NFT_CONFIG